import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginService } from '../../../services/login.service';
import { of, pipe, Subject, takeUntil } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { PdvService } from '../../../services/pdv.service';
import { AuthService } from '../../../services/auth.service';
import { AlertService } from '../../../services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from 'src/app/services/order.service';
import { select, Store } from '@ngrx/store';
import { PdvSelectors } from 'src/app/store/pdv/selectors';
import { RegisterService } from 'src/app/services/register.service';
import { environment } from 'src/environments/environment';
import { FormHelper } from '../../../helpers/form.helper';
import { HelperService } from 'src/app/services/helper.service';
import { MyProfileService } from "../../../services/my-profile.service" 

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public checkCpfForm!: FormGroup;
  public loginForm!: FormGroup;

  constructor(private formBuilder: FormBuilder,
    private loginService: LoginService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private pdvService: PdvService,
    private authService: AuthService,
    private helperService: HelperService,
    private alertService: AlertService,
    public orderService: OrderService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private store: Store,
    private registerService: RegisterService,
    private formHelper: FormHelper,
    private myProfileService: MyProfileService
  ) { }

  public loading: boolean = false; // verificando login

  public loginErrorMessages!: any; // mensagem de erro ao fazer login

  private unsubscribe$ = new Subject();

  public eventLink: string = ""

  public waitTimer: number = 0

  public waitTimer2: number = 0

  public showPassword: boolean = false

  private comissaryId: null | string = null;

  public loadingCompany: boolean = false;

  public companyId: string = ""

  private eventId: null | string = null;

  public redirectToCheckoutPage: boolean = false; // se tiver query param redirect=checkout redirectToCheckoutPage vai ser verdadeiro

  public redirectTo: string = ''; // redirecionar para a página que o usuário estava antes de ser redirecionado para o login

  public submitted: boolean = false; // formulário foi enviado ou não

  public producerLogin: boolean = false;
  public shouldCheckCpf: boolean = false;

  @Input() showProducerOption: boolean = true

  logo$ = this.store.pipe(
    select(PdvSelectors.selectCompany),
    map((company) => company?.images?.logosite ?? '')
  );

  ngOnInit(): void {
    this.loginFormStart();

    this.getCompany()
    this.activatedRoute.queryParams.subscribe((params) => {
      if ( params["login"] && params["login"] == "true") {
        this.producerLogin = true
      } 
    });
    // verifica sem tem query param redirect=checkout, se tiver, define redirectToCheckoutPage como verdadeiro
    if (this.activatedRoute.snapshot.queryParams['redirect']) {
      if (this.activatedRoute.snapshot.queryParams['redirect'] == 'checkout') {
        this.redirectToCheckoutPage = true;
      } else {
        this.redirectTo = this.activatedRoute.snapshot.queryParams['redirect'];
      }
    }


    // verifica sem tem query param org, se tiver, define a flag produtor como como verdadeiro
    if (this.activatedRoute.snapshot.queryParams['org']) {
      if (this.activatedRoute.snapshot.queryParams['org'] == 'produtor.ingressosa.com') {
        this.producerLogin = true;
      }
    }

    // verifica sem tem query param org=link-do-evento, se tiver, define eventLink
    if (this.activatedRoute.snapshot.queryParams['org']) {
      if (this.activatedRoute.snapshot.queryParams['org'] !== '') {
        this.eventLink = this.activatedRoute.snapshot.queryParams['org'];
      }
    }

    // id se houver comissário
    let rfr = this.activatedRoute.snapshot.queryParams['rfr'];
    if (rfr != null && rfr !== '') {
      // caso haja comissário irá salvar em uma variável que será passada ao método de pagamento
      this.eventId = this.activatedRoute.snapshot.queryParams['eventId'];
      this.comissaryId = rfr;
    }

    if (environment.authIntegration) {
      this.shouldCheckCpf = true;

      if (this.activatedRoute.snapshot.queryParams['doc']) {
        this.checkCpfForm.controls['cpf'].setValue(this.activatedRoute.snapshot.queryParams['doc']);
      }
    }
  }

  validateCheckCpf() {
    if (this.checkCpfForm.invalid == true) {
      if (this.checkCpfForm.controls['cpf'].errors) {
        if (this.checkCpfForm.controls['cpf'].errors['invalidCpf']) {
          this.alertService.toast({ icon: 'error', title: 'CPF', text: 'Cpf é inválido' })
        }
      }
    }
  }

  getCompany() {
    this.loadingCompany = true
    this.pdvService.load().subscribe((res) => {
      this.loadingCompany = false
      this.companyId = res.company.id
    })
  }


  showHidePassword() {
    let password = document.getElementById("floatingPassword") as any
    if (password.type == "password") {
      this.showPassword = true
      password.setAttribute("type", "text")
    } else {
      this.showPassword = false
      password.setAttribute("type", "password")
    }
  }

  loginFormStart() {
    if (this.producerLogin == true) {
      this.loginForm = this.formBuilder.group({
        'username': ['', [Validators.required]],
        'password': ['', [Validators.required, Validators.minLength(4)]],
        'rememberPasswordCheck': [false]
      });
    } else {
      this.loginForm = this.formBuilder.group({
        'email': ['', [Validators.email, Validators.required]],
        'password': ['', [Validators.required, Validators.minLength(4)]],
        'rememberPasswordCheck': [false]
      });
    }

    this.checkCpfForm = this.formBuilder.group({
      'cpf': ['', [Validators.required]]
    }, {
      validators: [
        this.formHelper.testCpf
      ]
    });
  }


  defineLoginProducer() {
    if (this.producerLogin == true) {
      this.producerLogin = false;
      this.loginFormStart();
    } else {
      this.producerLogin = true;
      this.loginFormStart();
    }
  }

  login() {
    if (this.producerLogin == true) {
      this.loginProducer()
    } else {
      this.loginCostumer();
    }
  }

  loginProducer() {
    // define submitted como verdadeiro
    this.submitted = true;
    this.authService.onlyLogout();
    // verifica se o formulário é válido
    if (this.loginForm.valid == true) {
      this.loading = true;

      this.waitTimer = 5;

      let timer = setInterval(function (this: any) {
        if (this.waitTimer <= 0) {
          this.waitTimer = 0
          clearInterval(timer)
        } else {
          this.waitTimer -= 1
        }

      }.bind(this), 1000)

      this.recaptchaV3Service.execute('loginProducer').subscribe((token) => {
        // salva os valores do formulário em uma variável de acordo com o LoginModel
        let loginForm = {
          username: this.loginForm.controls['username'].value,
          password: this.loginForm.controls['password'].value,
          rememberMe: this.loginForm.controls['rememberPasswordCheck'].value,
          token: token
        }


        // chama serviço para fazer login
        this.loginService.loginProducer(loginForm).pipe(
          catchError((error: any) => {
            this.loginErrorMessages = error.error.errors[0].msg;
            this.alertService.toast({ icon: 'error', title: 'Erro', text: this.loginErrorMessages });
            this.loading = false;
            return of(error);
          }),
          takeUntil(this.unsubscribe$)
        ).subscribe((res: any) => {
          if (res.error != null == false) {
            this.alertService.toast({ icon: 'success', title: 'Sucesso', text: 'Usuário logado' });
            //this.router.navigate(['producer']);
            res.rememberMe = loginForm.rememberMe

            window.location.href = "/producer"
            this.authService.saveProducer(res);
            this.loading = false;
          }
        });
      });
    }
  }


  loginCostumer(): void {
    // define submitted como verdadeiro
    this.submitted = true;
    // verifica se o formulário é válido
    if (this.loginForm.valid == true) {
      this.loading = true;

      this.waitTimer = 5;

      let timer = setInterval(function (this: any) {
        if (this.waitTimer <= 0) {
          this.waitTimer = 0
          clearInterval(timer)
        } else {
          this.waitTimer -= 1
        }

      }.bind(this), 1000)

      this.recaptchaV3Service.execute('loginCustomer').subscribe((token) => {
        let loginForm = {} as any
        // salva os valores do formulário em uma variável de acordo com o LoginModel caso tenha token do firebase   
        if (document.cookie.replace(/(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/, "$1") != "") {
          loginForm = {
            email: this.loginForm.controls['email'].value,
            password: this.loginForm.controls['password'].value,
            rememberMe: this.loginForm.controls['rememberPasswordCheck'].value,
            token: token,
            fcmToken: document.cookie.replace(/(?:(?:^|.*;\s*)token\s*\=\s*([^;]*).*$)|^.*$/, "$1")
          }
        } else {  // salva os valores do formulário em uma variável de acordo com o LoginModel caso não tenha token do firebase   
          loginForm = {
            email: this.loginForm.controls['email'].value,
            password: this.loginForm.controls['password'].value,
            rememberMe: this.loginForm.controls['rememberPasswordCheck'].value,
            token: token,
          }
        }

        // chama serviço para fazer login
        this.loginService.loginCostumer(loginForm).pipe(
          catchError((error: any) => {
            this.loginErrorMessages = error.error.errors[0].msg;
            this.alertService.toast({ icon: 'error', title: 'Erro', text: this.loginErrorMessages });
            this.loading = false;
            return of(error);
          }),
          takeUntil(this.unsubscribe$)
        ).subscribe((res: any) => {
          if (res.doc) {
            this.authService.producerOnlyLogout();
            this.alertService.toast({ icon: 'success', title: 'Sucesso', text: 'Usuário logado' });
            if (this.redirectToCheckoutPage == false) {
              if (this.redirectTo != '') {
                this.router.navigate([this.redirectTo]);
              } else {
                this.router.navigate(['/']);
              }

              this.activatedRoute.queryParams.subscribe((params) => {
                if (document.location.host.replace('www.', '').startsWith("comissario.meubilhete.com.br")) {
                  this.myProfileService.defineModeComissioner(true);
                } 
              });


              

            } else {
              if (this.comissaryId !== null) {
                this.router.navigateByUrl('payment-method/' + this.eventId + '?rfr=' + this.comissaryId);
              } else {
                this.orderService.currentOrder
                  .pipe(takeUntil(this.unsubscribe$))
                  .subscribe(order => {
                    if (order != null) {
                      if (order.event != null) {
                        if (order.tickets.length >= 1) {
                          this.activatedRoute.queryParams.subscribe((res) => {
                            let items = this.helperService.getUtm(res)
                            if (items != null && items != "") {
                              this.router.navigateByUrl('/payment-method?' + items);
                              return;
                            }

                            this.router.navigate(['../payment-method']);
                          })
                        } else {
                          this.alertService.toast({ icon: 'error', title: 'Erro ao proseguir', text: 'Por favor escolha seus ingressos novamente' });
                          this.router.navigateByUrl(this.eventLink);
                        }
                      } else {
                        this.alertService.toast({ icon: 'error', title: 'Erro ao proseguir', text: 'Por favor escolha seus ingressos novamente' });
                        this.router.navigateByUrl(this.eventLink);
                      }
                    } else {
                      this.alertService.toast({ icon: 'error', title: 'Erro ao proseguir', text: 'Por favor escolha seus ingressos novamente' });
                      this.router.navigateByUrl(this.eventLink);
                    }
                  })
              }
            }

            res.rememberMe = loginForm.rememberMe

            this.authService.saveCustomer(res);
            // if (this.redirectToCheckoutPage == false) {
            //   this.router.navigateByUrl('/');
            // } else {
            //   this.router.navigateByUrl('../event?checkout=true');
            // }
            this.loading = false;
          }
        });
      });
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  async checkCpf() {
    this.loading = true;
    const re: any = await this.registerService.checkAuthIntegration(this.checkCpfForm.controls['cpf'].value).toPromise();
    this.loading = false;
    if (!re.internalAuthInfo?.id) {
      this.alertService.toast({ icon: 'warning', title: 'Atenção', text: 'Verifique os dados do seu cadastro' });
      const params = { doc: this.checkCpfForm.controls['cpf'].value }
      if (this.redirectToCheckoutPage) {
        params['redirect'] = 'checkout';
      }

      this.router.navigate(['/auth/register'], { queryParams: params });
    } else {
      this.shouldCheckCpf = false;
    }
  }

}
